import React from 'react';

const FeatureVisual = ({ className }) => (
    <img
        src={process.env.PUBLIC_URL + '/assets/features/feature-visual.svg'}
        alt="Adaptive AI Practice"
        className={className}
    />
);

export default FeatureVisual;
